import React, { Component } from "react";
import { Add, Remove } from "@material-ui/icons";
import { connect } from "react-redux";
import { preciseNumber } from "../../store/reducers/cart";
import { changeQuantity, setFromQuantityBox } from "../Menu/Helpers";
import QuantityBoxDialog from "./QuantityBoxDialog";
import Grid from "@material-ui/core/Grid";
import { editProduct } from "../../store/actions";
import { getProductInventory } from "../../store/reducers/store";
class ProductQuantity extends Component {
  state = {
    openQuantityDialog: false,
  };

  componentDidMount() {
    if (this.props.editedProduct) {
      return;
    }
    const { usedComponents } = this.props;
    let newQuantity = 0;
    const includesPromo =
      this.props.promo_items_addable_quantity &&
      this.props.promo_items_addable_quantity > 0;

    if (includesPromo) {
      newQuantity = this.props.promo_items_addable_quantity;
    } else if (this.props.current_product.min_addable_quantity > 0) {
      newQuantity = this.props.current_product.min_addable_quantity;
    }

    if (newQuantity > 0) {
      switch (this.props.current_product.type_of_product) {
        case "composite":
        case "stocked":
          let inventory = getProductInventory(
            this.props.current_product,
            usedComponents
          );

          newQuantity = Math.min(newQuantity, inventory);

          if (
            this.props.current_product.max_addable_quantity !== null &&
            !includesPromo
          ) {
            newQuantity = Math.min(
              newQuantity,
              this.props.current_product.max_addable_quantity -
                this.props.addedQuantity
            );
          }
          break;
        default:
          if (
            this.props.current_product.max_addable_quantity !== null &&
            !includesPromo
          ) {
            newQuantity = Math.min(
              newQuantity,
              this.props.current_product.max_addable_quantity -
                this.props.addedQuantity
            );
          }
      }
    }
    if (newQuantity > 0) {
      // this.setState({ Quantity: newQuantity });
      this.props.SetQuantity(newQuantity);
    }
  }
  componentDidUpdate(prevProps) {
    const { usedComponents } = this.props;
    if (
      prevProps.booking_slot !== this.props.booking_slot ||
      prevProps.current_product.id !== this.props.current_product.id ||
      prevProps.addedQuantity !== this.props.addedQuantity
    ) {
      let newQuantity = 1;
      const includesPromo =
        this.props.promo_items_addable_quantity &&
        this.props.promo_items_addable_quantity > 0;
      if (includesPromo) {
        newQuantity = this.props.promo_items_addable_quantity;
      } else if (this.props.current_product.min_addable_quantity > 1) {
        newQuantity = this.props.current_product.min_addable_quantity;
      }

      switch (this.props.current_product.type_of_product) {
        case "composite":
        case "stocked":
          let inventory = getProductInventory(
            this.props.current_product,
            usedComponents
          );
          newQuantity = Math.min(newQuantity, inventory);
          if (
            this.props.current_product.max_addable_quantity !== null &&
            !includesPromo
          ) {
            newQuantity = Math.min(
              newQuantity,
              this.props.current_product.max_addable_quantity -
                this.props.addedQuantity
            );
          }
          break;
        case "bookable":
          if (this.props.booking_slot !== -1) {
            const bookingSlot = this.props.current_product.booking_slots.find(
              (slot) => slot.id === this.props.booking_slot
            );
            if (!bookingSlot) break;
            newQuantity = Math.min(newQuantity, bookingSlot.inventory);

            if (
              this.props.current_product.max_addable_quantity !== null &&
              !includesPromo
            ) {
              newQuantity = Math.min(
                newQuantity,
                this.props.current_product.max_addable_quantity -
                  this.props.addedQuantity
              );
            }
          }
          break;

        default:
          if (
            this.props.current_product.max_addable_quantity !== null &&
            !includesPromo
          ) {
            newQuantity = Math.min(
              newQuantity,
              this.props.current_product.max_addable_quantity -
                this.props.addedQuantity
            );
          }
      }

      if (newQuantity > 0) {
        // this.setState({ Quantity: newQuantity });
        this.props.SetQuantity(newQuantity);
      }
    }
  }

  getButtonDisabled = () => {
    if (
      this.props.current_product.type_of_product === "bookable" &&
      this.props.booking_slot === -1
    ) {
      return true;
    }
    return false;
  };
  openQuantityDialog = (e) => {
    e.stopPropagation();
    this.setState({ openQuantityDialog: true });
  };
  render() {
    const { settings, themeColor, language, editedProduct } = this.props;
    const { openQuantityDialog } = this.state;
    const disabled = this.getButtonDisabled();
    const increments = parseFloat(this.props.current_product.increments);

    return (
      <div
        className={
          settings.quantity_box_location === "bottom" &&
          "border-top border-bottom mt-4 noselect"
        }
        style={{
          backgroundColor:
            settings.quantity_box_location === "bottom" && "white",
          height: "60px",
          lineHeight: "28px",
          alignItems: "center",
          display: "flex",
          justifyContent:
            settings.quantity_box_location === "bottom" && "space-between",
        }}
      >
        {settings.quantity_box_location === "bottom" && (
          <p
            className={"text-muted mt-3 ".concat(
              this.props.language == "english"
                ? "float-left mx-4"
                : "float-right mx-4"
            )}
            style={{ lineHeight: 2 }}
          >
            {this.props.language == "english" ? "Quantity" : "الكمية"}
          </p>
        )}
        <Grid
          className={"mx-3 ".concat(
            this.props.language == "english" ? "float-right " : "float-left "
          )}
          direction={language === "arabic" && "row-reverse"}
          alignItems="center"
          justify="space-evenly"
          container
          style={{
            width: 125,
            backgroundColor: "white",
            height: "55%",
            border: "1px solid #DEDEDE",
            borderRadius: 50,
            display: "flex",
            alignContent: "center",
          }}
        >
          <Grid
            item
            style={{
              textAlign: "center",
              width: "30px",
            }}
            onClick={() => {
              if (!disabled) {
                const newQuantity = changeQuantity(
                  -increments,
                  this.props.quantity,
                  this.props
                );
                if (newQuantity !== null) {
                  // this.setState({ Quantity: newQuantity });
                  this.props.SetQuantity(newQuantity);
                }
              } else {
                this.props.scrollToBookables();
              }
            }}
          >
            <Remove style={{ color: themeColor, fontSize: 15 }} />
          </Grid>
          <Grid
            item
            onClick={
              (!disabled && this.openQuantityDialog) ||
              this.props.scrollToBookables
            }
          >
            {openQuantityDialog && (
              <QuantityBoxDialog
                changeQuantity={(i) => {
                  const newQuantity = setFromQuantityBox(
                    i,
                    this.props.quantity,
                    this.props
                  );
                  if (newQuantity != null) {
                    // this.setState({ Quantity: newQuantity });
                    this.props.SetQuantity(newQuantity);
                  }
                }}
                closeModal={() => this.setState({ openQuantityDialog: false })}
                quantity={this.props.quantity}
                editedProduct={editedProduct}
              />
            )}
            <div
              className="text-center"
              style={{
                color: themeColor,
                border: "1px solid #DEDEDE",
                width: 60,
                padding: "2px 0px 2px 0px",
                margin: 0,
                overflow: "hidden",
                borderTop: 0,
                borderBottom: 0,
              }}
            >
              {parseFloat(
                this.props.quantity.toFixed(settings.currency_decimals)
              )}
            </div>
          </Grid>
          <Grid
            style={{
              textAlign: "center",
              width: "30px",
            }}
            item
            onClick={() => {
              if (!disabled) {
                const newQuantity = changeQuantity(
                  increments,
                  this.props.quantity,
                  this.props
                );
                if (newQuantity !== null) {
                  // this.setState({ Quantity: newQuantity });
                  this.props.SetQuantity(newQuantity);
                }
              } else {
                this.props.scrollToBookables();
              }
            }}
          >
            <Add style={{ color: themeColor, fontSize: 15 }} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
    usedComponents: state.store.used_components,
  };
};

export default connect(mapStateToProps)(ProductQuantity);
